import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { taskTypeApi } from 'app/services/api';

import { selectMasterCompanyId } from 'store/auth/selectors';

const useTaskTypeAction = ({ taskTypeId, isEnabled }) => {
  const companyId = useSelector(selectMasterCompanyId);

  const [state, setState] = useState({ taskTypeId: null, taskTypeAction: null });

  useEffect(() => {
    if (!isEnabled || !taskTypeId) {
      return;
    }

    const request = { isCancelled: false };

    taskTypeApi
      .getType({ companyId, taskTypeId })
      .then(({ data }) => {
        if (!request.isCancelled) {
          setState({
            taskTypeId,
            taskTypeAction: data.action ? { ...data.action, taskTypeId } : null,
          });
        }
      })
      .catch(() => {
        if (!request.isCancelled) {
          setState({ taskTypeId, taskTypeAction: null });
        }
      });

    return () => {
      request.isCancelled = true;
    };
  }, [companyId, isEnabled, taskTypeId]);

  return isEnabled && state.taskTypeId === taskTypeId ? state.taskTypeAction : null;
};

export default useTaskTypeAction;
